<div class="bg-white" id="layoutError">
    <div id="layoutError_content">
        <main>
            <div class="container-xl px-4">
                <div class="row gx-4 justify-content-center">
                    <div class="col-lg-6">
                        <div class="text-center mt-4">
                            <img class="img-fluid p-4" src="assets/img/illustrations/401-error-unauthorized.svg" alt="" />
                            <p class="lead">Access to this resource is denied.</p>
                            <a class="text-arrow-icon" routerLink="/dashboard"
                                ><i-feather class="ms-0 me-1" name="arrow-left"></i-feather>Return to Dashboard</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
    <div id="layoutError_footer">
        <footer class="footer-admin mt-auto footer-light">
            <div class="container-fluid px-4">
                <div class="row gx-4">
                    <div class="col-md-6 small">Copyright &copy; Your Website 2022</div>
                    <div class="col-md-6 text-md-end small">
                        <a href="javascript:void(0);">Privacy Policy</a>
                        &middot;
                        <a href="javascript:void(0);">Terms &amp; Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</div>
